import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';

import get from 'lodash.get';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    SprayWorksheetEntitySummary
} from 'services/worksheet/types';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectSprayWorksheetEntitySummaries = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (sprayWorksheetState, index) =>
        get(sprayWorksheetState, [
            'pages',
            index,
            'entitySummaries'
        ]) as SprayWorksheetEntitySummary[]
);

const makeSelectSprayWorksheetEntitySummaries =
    (): typeof selectSprayWorksheetEntitySummaries =>
        selectSprayWorksheetEntitySummaries;

export {
    selectPageIndex,
    selectSprayWorksheetEntitySummaries,
    makeSelectSprayWorksheetEntitySummaries
};
